import React, { Component } from "react";
import { connect } from "react-redux";
import { moveFutureTenant } from "../../actions/tenancyActions";
import {
  addFutureTenant,
  archiveFutureTenant,
} from "../../actions/tenancyActions";
import isEmpty from "../../validation/is-empty";
import axios from "axios";

// import components
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Moment from "react-moment";

class ManageFutureTenant extends Component {
  constructor() {
    super();

    this.state = {
      selectedUser: null,
      query: "",
      queryResults: [],
      startDate: new Date(),
      endDate: new Date(),
      rentalValue: 0,
    };

    this.onChange = this.onChange.bind(this);
    this.tenantSearch = this.tenantSearch.bind(this);
    this.selectTenant = this.selectTenant.bind(this);
    this.addFutureTenant = this.addFutureTenant.bind(this);
    this.removeFutureTenant = this.removeFutureTenant.bind(this);
    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.handleEndDateChange = this.handleEndDateChange.bind(this);
    this.moveFutureTenant = this.moveFutureTenant.bind(this);
  }

  componentDidMount() {
    this.setState({ rentalValue: this?.props?.room?.price });
  }

  onChange(e) {
    e.preventDefault();

    this.setState({ [e.target.name]: e.target.value });
  }

  tenantSearch(e) {
    this.setState({ [e.target.name]: e.target.value });

    axios
      .get(`/api/auth/users/future-tenant-search/${e.target.value}`)
      .then((data) => {
        this.setState({ queryResults: data.data });
      })
      .catch((err) => {
        this.setState({ queryResults: [] });
      });
  }

  selectTenant(user) {
    this.setState({ selectedUser: user, query: "", queryResults: [] });
  }

  handleStartDateChange(date) {
    this.setState({ startDate: date });
  }

  handleEndDateChange(date) {
    this.setState({ endDate: date });
  }

  addFutureTenant(e) {
    const { room } = this.props;
    const user = this.state.selectedUser;

    let tenancyInfo = {
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      rentalValue: this.state.rentalValue,
    };

    this.props.addFutureTenant(room?._id, user?._id, tenancyInfo);
  }

  removeFutureTenant(e) {
    const { tenant } = this.props;
    const { room } = this.props;
    e.preventDefault();

    this.setState({
      selectedUser: "",
      startDate: new Date(),
      endDate: new Date(),
    });

    this.props.archiveFutureTenant(room?._id, tenant?.user?._id);
  }

  moveFutureTenant(e) {
    e.preventDefault();
    const { tenant } = this.props;

    this.setState({
      selectedUser: "",
      startDate: new Date(),
      endDate: new Date(),
    });

    this.props.moveFutureTenant(tenant._id);
  }

  render() {
    const { tenant, errors } = this.props;
    const { queryResults, query, selectedUser } = this.state;

    let tenantContent;

    if (isEmpty(tenant)) {
      tenantContent = (
        <div className="row">
          <div className="col-12">
            <p>
              Search for a tenant below and select their name to add them to a
              property. Only users that aren't assigned to other rooms will
              appear in the query results.
            </p>
          </div>
          <div className="col-md-6">
            <div className="field">
              <h5 className="heading">Add a tenant</h5>
              {selectedUser ? (
                <div className="selected-user">
                  <div className="meta">
                    {selectedUser?.name}
                    <span className="d-block">{selectedUser.email}</span>
                  </div>

                  <button
                    className="delete-icon"
                    onClick={() => this.setState({ selectedUser: null })}
                  >
                    <span className="fa-stack">
                      <i className="fas fa-circle fa-stack-2x" />
                      <i className="fas fa-times fa-stack-1x fa-inverse" />
                    </span>
                  </button>
                </div>
              ) : (
                <React.Fragment>
                  <input
                    type="text"
                    name="query"
                    placeholder="Search by name"
                    onChange={this.tenantSearch}
                    autoComplete="off"
                  />

                  {query.length > 0 ? (
                    <div className="query-results">
                      <ul>
                        {queryResults.length > 0 ? (
                          queryResults.map((user) => (
                            <li key={user?._id}>
                              <button onClick={() => this.selectTenant(user)}>
                                {user?.name }
                                <span className="d-block">{user.email}</span>
                              </button>
                            </li>
                          ))
                        ) : (
                          <li className="p-3">No results found</li>
                        )}
                      </ul>
                    </div>
                  ) : null}
                </React.Fragment>
              )}
            </div>
          </div>

          <div className="col-md-6">
            <div className="field">
              <h5 className="heading">Tenancy Start Date</h5>
              <DatePicker
                selected={this.state.startDate}
                onChange={this.handleStartDateChange}
                dateFormat="dd/MM/yyyy"
              />
            </div>
          </div>

          <div className="col-md-6">
            <div className="field">
              <h5 className="heading">Tenancy End Date</h5>
              <DatePicker
                selected={this.state.endDate}
                onChange={this.handleEndDateChange}
                dateFormat="dd/MM/yyyy"
              />
            </div>
          </div>

          <div className="col-md-6">
            <div className="field">
              <h5 className="heading">Weekly Rent</h5>
              <input
                type="text"
                name="rentalValue"
                value={this.state.rentalValue}
                onChange={this.onChange}
              />
            </div>
          </div>

          {errors.futureTenant ? (
            <div className="col-12">
              <div className="field">
                <p className="text-danger">{errors.futureTenant}</p>
              </div>
            </div>
          ) : null}

          <div className="col-12">
            <div className="field">
              <button
                className="btn green-button"
                disabled={isEmpty(this.state.selectedUser)}
                onClick={this.addFutureTenant}
              >
                Add Tenant
              </button>
            </div>
          </div>
        </div>
      );
    } else {
      tenantContent = (
        <div className="row">
          <div className="col-lg-4 col-md-6">
            <div className="field">
              <h5 className="heading">Name</h5>
              <p>{tenant?.user?.name}</p>
            </div>
          </div>

          <div className="col-lg-4 col-md-6">
            <div className="field">
              <h5 className="heading">Email</h5>
              <p>{tenant?.user?.email}</p>
            </div>
          </div>

          <div className="col-lg-4 col-md-6">
            <div className="field">
              <h5 className="heading">User ID</h5>
              <p>{tenant?.user?._id}</p>
            </div>
          </div>

          <div className="col-lg-4 col-md-6">
            <div className="field">
              <h5 className="heading">Start Date</h5>
              <p>
                {tenant.startDate ? (
                  <Moment format="DD/MM/YYYY">{tenant.startDate}</Moment>
                ) : (
                  "-"
                )}
              </p>
            </div>
          </div>

          <div className="col-lg-4 col-md-6">
            <div className="field">
              <h5 className="heading">End Date</h5>
              <p>
                {tenant.endDate ? (
                  <Moment format="DD/MM/YYYY">{tenant.endDate}</Moment>
                ) : (
                  "-"
                )}
              </p>
            </div>
          </div>

          <div className="col-lg-4 col-md-6">
            <div className="field">
              <h5 className="heading">Weekly Rent</h5>
              <p>{tenant.rentalValue ? tenant.rentalValue : "-"}</p>
            </div>
          </div>

          {errors.futureTenant ? (
            <div className="col-12">
              <div className="field">
                <p className="text-danger">{errors.futureTenant}</p>
              </div>
            </div>
          ) : null}

          {errors.moveTenant ? (
            <div className="col-12">
              <div className="field">
                <p className="text-danger">{errors.moveTenant}</p>
              </div>
            </div>
          ) : null}

          <div className="col-12">
            <div className="field">
              <button
                className="btn red-button"
                onClick={this.removeFutureTenant}
              >
                Archive Tenant
              </button>
              {isEmpty(this?.props?.room?.tenant) ? (
                <button
                  className="btn green-button ml-3"
                  onClick={this.moveFutureTenant}
                >
                  Move To Current Tenant
                </button>
              ) : null}
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="edit-section">
        <h3 className="heading">Manage Future Tenant</h3>
        {tenantContent}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
});

export default connect(mapStateToProps, {
  addFutureTenant,
  archiveFutureTenant,
  moveFutureTenant,
})(ManageFutureTenant);
